import React from 'react';

import { Grid, Typography } from '@mui/material';
import Select from './base/Select';
import booleanChoices from '../../../constants/booleanChoices';

const StateOwned = () => (
  <Grid container spacing={10}>
    <Grid size={12}>
      <Typography
        color="#646464"
        variant="h6"
      >
        Is the company owned by a state, region, municipality or equivalent?
      </Typography>
    </Grid>
    <Select choices={booleanChoices.en} />
  </Grid>
);

export default StateOwned;
